/** EvolveRPG — English world-UI overrides. Fast-play, momentum-driven voice. */
export const worldEvoEn = {
  'world.seo.description':
    'Explore the interactive maps of EvolveRPG — every genre, every setting, in 2D cartograph and a rotatable 3D globe.',
  'world.intro':
    'Chart every genre EvolveRPG supports. The atlas is built for nested vision — zoom from the whole map down to a single scene. Only the topmost tier is interactive for now; deeper tiers open as more settings launch.',

  'world.gazetteer.sampleNotice': 'Showing sample places — the full survey is still being mapped.',
  'world.gazetteer.error': 'The atlas archive could not be reached.',

  'world.loading.atlas': 'Loading the atlas…',
  'world.loading.globe': 'Spinning the world…',


  'world.globe.uncharted': 'Unclaimed Territory',
  'world.globe.unchartedBlurb': 'No campaign has claimed this hex yet. Drop in and stake the first banner.',
  'world.globe.capitalLabel': 'The Hub',
} as const
